<template>
  <section>
    <div class="columns is-multiline is-vcentered">
      <div class="column is-paddingless pt-3">
        <div class="columns is-marginless is-multiline">
          <!-- Header -->
          <div v-if="!!this.$slots.header" class="column is-full">
            <slot name="header"></slot>
          </div>
          <!-- Invisible space to keep height -->
          <div v-else-if="imagesCount > 1" class="column is-full">‏‏‎ㅤ</div>

          <!-- Main Picture -->
          <div v-if="imagesCount" class="column is-full">
            <transition name="fade" tag="figure" mode="out-in">
              <a
                class="column is-full list-item"
                @click="openGallery(activeImage)"
                :key="getPicture(activeImage)"
              >
                <figure
                  @before-leave="beforeLeave"
                  class="image is-square"
                  :key="getPicture(activeImage)"
                  @click="openGallery(activeImage)"
                >
                  <img
                    class="mainImage"
                    :src="getPicture(activeImage)"
                    alt="Step image"
                  />
                </figure>
              </a>
            </transition>
          </div>
          <div v-else class="column is-full">
            <transition name="fade" tag="figure" mode="out-in">
              <div class="column is-full list-item">
                <figure @before-leave="beforeLeave" class="image is-square">
                  <img
                    class="mainImage"
                    src="https://costuto-public.s3.eu-central-1.amazonaws.com/images/placeholder_1x1.png"
                    alt="Placeholder"
                  />
                </figure>
              </div>
            </transition>
          </div>

          <!-- Footer -->

          <div v-if="!!this.$slots.footer" class="column is-full">
            <slot name="footer"></slot>
          </div>
          <!-- Invisible space to keep height -->
          <div v-else-if="imagesCount > 1" class="column is-full">‏‏‎ㅤ</div>
        </div>
      </div>

      <!-- Navigation -->
      <div v-if="imagesCount > 1" class="column is-3 is-paddingless pt-3">
        <transition-group
          @before-leave="beforeLeave"
          name="list"
          tag="div"
          class="columns is-marginless is-paddingless is-multiline"
        >
          <!-- Chevron Up -->
          <div class="column has-text-centered is-full" key="0">
            <a v-if="imagesCount > 3" @click="decreaseOffset">
              <b-icon type="is-primary" icon="chevron-up"></b-icon>
            </a>
            <b-icon v-else type="is-gray" icon="chevron-up"></b-icon>
          </div>

          <!-- Navigation images -->
          <a
            v-for="n in 3"
            class="column is-full list-item"
            @click="activeImage = n - 1"
            :key="getPicture(n - 1)"
          >
            <figure class="image is-square">
              <img
                v-bind:style="activeImage == n - 1 ? activeStyle : inactiveStyle"
                :src="getPicture(n - 1)"
                alt="Step image"
              />
            </figure>
          </a>

          <!-- Chevron Down -->
          <div class="column has-text-centered is-full" key="5">
            <a v-if="imagesCount > 3" @click="increaseOffset">
              <b-icon type="is-primary" icon="chevron-down"></b-icon>
            </a>
            <b-icon v-else type="is-gray" icon="chevron-down"></b-icon>
          </div>
        </transition-group>
      </div>
    </div>

    <LightBox
      ref="lightbox"
      :media="lightBoxImages"
      :show-caption="true"
      :show-light-box="false"
    ></LightBox>
  </section>
</template>

<script>
import LightBox from 'vue-it-bigger'
export default {
  props: ['images'],
  data () {
    return {
      offset: 0,
      activeImage: 0,
      inactiveStyle: {
        borderRadius: '10%'
      },
      activeStyle: {
        borderRadius: '10%',
        border: '0.3rem solid #3acfb9'
      }
    }
  },
  computed: {
    imagesCount () {
      return this.images.length
    },
    lightBoxImages () {
      return this.images.map((image) => {
        return {
          src: image.attributes.content.url,
          thumb: image.attributes.content.url,
          caption: image.attributes.caption
        }
      })
    }
  },
  components: {
    LightBox
  },
  methods: {
    openGallery (position) {
      let offetPosition = (position + this.offset) % this.images.length
      this.$refs.lightbox.showImage(offetPosition)
    },
    getPicture (position) {
      let offetPosition = (position + this.offset) % this.images.length
      return this.images[offetPosition].attributes.content.url
    },
    getPictureId (position) {
      let offetPosition = (position + this.offset) % this.images.length
      return this.images[offetPosition].id
    },
    increaseOffset () {
      this.offset = this.offset + 1
    },
    decreaseOffset () {
      if (this.offset === 0) this.offset = this.imagesCount - 1
      else this.offset--
    },
    beforeLeave (el) {
      const { marginLeft, marginTop, width, height } = window.getComputedStyle(el)
      el.style.left = `${el.offsetLeft - parseFloat(marginLeft, 10)}px`
      el.style.top = `${el.offsetTop - parseFloat(marginTop, 10)}px`
      el.style.width = width
      el.style.height = height
    }
  }
}
</script>

<style lang="scss" scoped>
.list-item {
  transition: all 0.2s;
}
.list-move {
  transition: transform 0.2s;
}
.list-enter,
.list-leave-to {
  opacity: 0;
}

.list-enter-active {
  transition: opacity 0.1s;
  opacity: 0;
}

.list-leave-active {
  position: fixed;
}
.fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.1s ease;
}
.fade-enter,
.component-fade-leave-to {
  opacity: 0;
}

.mainImage {
  border-radius: 5%;
}
</style>
